import SeguroColectivoSalud from '@/components/Servicios/ServiciosEmpresas/SeguroColectivoSalud'
import ParaEmpresas from '@/components/Servicios/ServiciosEmpresas/ParaEmpresas'
import Empresas from '@/components/Servicios/Empresas'
import MultirriesgoCopropiedades from '@/components/Servicios/ServiciosEmpresas/MultirriesgoCopropiedades'
import FraudeEmpleados from '@/components/Servicios/ServiciosEmpresas/FraudeEmpleados'
import cumplimientoDisposicionesLegal from '@/components/Servicios/ServiciosEmpresas/cumplimientoDisposicionesLegal'
import SeguroColectivoVida from '@/components/Servicios/ServiciosEmpresas/SeguroColectivoVida'
import TodoRiesgoEmpresarial from '@/components/Servicios/ServiciosEmpresas/TodoRiesgoEmpresarial'
import InfidelidadRiesgosFinancieros from '@/components/Servicios/ServiciosEmpresas/InfidelidadRiesgosFinancieros'
import ProteccionDigitalEmpresas from '@/components/Servicios/ServiciosEmpresas/ProteccionDigitalEmpresas'
import CumplimientoConstratistasProveedores from '@/components/Servicios/ServiciosEmpresas/CumplimientoConstratistasProveedores'
import MultirriesgoCorporativo from '@/components/Servicios/ServiciosEmpresas/MultirriesgoCorporativo'
import ResponsavilidadCivilDanoTerceros from '@/components/Servicios/ServiciosEmpresas/ResponsavilidadCivilDanoTerceros'
import SeguroConstruccion from '@/components/Servicios/ServiciosEmpresas/SeguroConstruccion'
import SeguroMaquinariaEquipoContratistas from '@/components/Servicios/ServiciosEmpresas/SeguroMaquinariaEquipoContratistas'
import SeguroTransTerrestreCarga from '@/components/Servicios/ServiciosEmpresas/SeguroTransTerrestreCarga'
import seguroTransMercanciasEspecifico from '@/components/Servicios/ServiciosEmpresas/seguroTransMercanciasEspecifico'

export default {
    path: 'empresas/',
    component: ParaEmpresas,
    children: [
        {
            path: '',
            component: Empresas
        },
        {
            path: 'seguro-colectivo-salud',
            component: SeguroColectivoSalud
        },
        {
            path: 'multirriesgo-copropiedades',
            component: MultirriesgoCopropiedades
        },
        {
            path: 'fraude-empleados',
            component: FraudeEmpleados
        },
        {
            path: 'cumplimiento-disposiciones-legal',
            component: cumplimientoDisposicionesLegal
        },
        {
            path: 'colectivo-vida',
            component: SeguroColectivoVida
        },
        {
            path: 'todo-riesgo-empresarial',
            component: TodoRiesgoEmpresarial
        },
        {
            path: 'infidelidad-riegos-financieros',
            component: InfidelidadRiesgosFinancieros
        },
        {
            path: 'proteccion-digital-empresas',
            component: ProteccionDigitalEmpresas
        },
        {
            path: 'cumplimiento-contrastistas-proveedores',
            component: CumplimientoConstratistasProveedores
        },
        {
            path: 'multiriesgo-corporativo',
            component: MultirriesgoCorporativo
        },
        {
            path: 'responsabilidad-civil-daños-terceros',
            component: ResponsavilidadCivilDanoTerceros
        },
        {
            path: 'seguro-construccion',
            component: SeguroConstruccion
        },
        {
            path: 'seguro-maquinaria-equipo-contratistas',
            component: SeguroMaquinariaEquipoContratistas
        },
        {
            path: 'seguro-trans-terrestre-carga',
            component: SeguroTransTerrestreCarga
        },
        {
            path: 'seguro-trans-mercancias-especifico',
            component: seguroTransMercanciasEspecifico
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/empresas.js